import { useState, useCallback } from 'react'
import { IS_NAV_BAR_OPEN } from 'constants/nav'

// Nav is expanded by default unless localStorage value exists
export const getInitialNavState = (): boolean => {
  try {
    const isOpenLocal = localStorage.getItem(IS_NAV_BAR_OPEN)
    return isOpenLocal !== 'false'
  } catch {
    return true
  }
}

interface IUseNavState {
  isNavOpen: boolean
  isNavExpanded: boolean
  setNavOpen: (isOpen: boolean) => void
  toggleNav: () => void
  setNavExpanded: (isExpanded: boolean) => void
  toggleExpand: () => void
}

interface IUseNavProps {
  /**
   * Sets default state of nav (open/closed)
   * @default false
   */
  initialState?: boolean
  /**
   * Sets default state of nav (expanded/minified)
   * @default true
   */
  initialExpanded?: boolean
}

const DEFAULT_USE_NAV_CONFIG: IUseNavProps = {
  initialState: false,
  initialExpanded: true,
}

/**
 * Used to manage state for nav
 */
export const useNav = ({
  initialExpanded = true,
  initialState = false,
}: IUseNavProps = DEFAULT_USE_NAV_CONFIG): IUseNavState => {
  const [isNavOpen, setNavOpen] = useState<boolean>(initialState)
  const [isNavExpanded, setNavExpanded] = useState<boolean>(initialExpanded)

  const toggleNav = useCallback(() => {
    setNavOpen(prevState => !prevState)
  }, [])

  const toggleExpand = useCallback(() => {
    setNavExpanded(prevState => !prevState)
  }, [])

  return {
    isNavOpen,
    isNavExpanded,
    toggleNav,
    toggleExpand,
    setNavOpen,
    setNavExpanded,
  }
}
